// select preferred date
// select select no of guests
import React, { useEffect } from "react";
import { useState } from "react";
import Loader from "../../UI/loader";
import { setLoader } from "../../action/homeAction";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { format } from "date-fns";
import { getAvailableActivities } from "../../../action/activityBooking";
import { CMSPath } from "../../../config/constant";
import { sendAnalytics } from "../../../action/homeAction";
import { closeOrderPopUp } from "../../action/hCommerce2";
import { setGoHome } from "../../action/homeAction";
import { DayPicker } from "react-day-picker";
import { getDefaultAnalyticsLabel } from "../../JS/utility";
import moment from "moment";
import { popupOpenClose } from "../../../action/action";
import { scrollToTop } from "../../../JS/scrollToTop";
 


export const formatDateAsDateFormat = (date, format) => {
  console.log("props.dateFormat", format);

  if (!date || date == null) {
    return;
  }

  const dateObj = moment(date);
  return dateObj.format(
    `${format && format != "null" ? format.toUpperCase() : "YYYY-MM-DD"}`
  );
};
function Activities3(props) {
  const { t } = props;
  const [guestCount, setGuestCount] = useState(props.bookingData.totalGuests ? String(props.bookingData.totalGuests) : '1');
  const [selectedDate, setSelectedDate] = useState(props.bookingData.preferredDate ? props.bookingData.preferredDate : null);
  const [showLoader, setShowLoader] = useState(false);
  const [renderDatePicker, setRenderDatePicker] = useState(false)

  let label = getDefaultAnalyticsLabel({
    appVersion: props.installedAppVersion
      ? `${props.installedAppVersion}(${props.installedAppBuildNo})`
      : "",
  });
  let dateInputCss = `
    .rdp-day_selected {
        color: ${props.menuColor.assetFontSelectorColor};
        background-color: ${props.menuColor.assetBackgroundSelectorColor};
    }`;

  let widgetSesstionId = localStorage.getItem("activityBookingSessionToken");



  const handleNext = () => {

    if(!selectedDate)
      {
      props.popupOpenClose(true, t("activityBooking.select_preferred_date_popup"));
        return;
      }
      if( isNaN(Number(guestCount)) ||  Number(guestCount)<=0){
        props.popupOpenClose(true, t("activityBooking.invalid_no_of_guests"));
        return;
      }

    setShowLoader(true);

    //API CALLING 
    // setActivitiesAvailable
    const payload={
      "serviceType": "activity",
      "dateTime": formatDateAsDateFormat(selectedDate,"YYYY-MM-DD"), // "2024-05-25",
      "totalGuests": Number(guestCount), 
      "spaLocationId": props.bookingData.spaLocationId  
    }
    getAvailableActivities(payload)
      .then((res) => {
        if (res.status == 200 && (res && res.data && res.data.header && res.data.header.status && res.data.header.status.code == "SUCCESS")) {

          let data = res.data.payload.data.Activities;

          data.sort((a, b) => {
            return (
              new Date(a.date).getTime() -
              new Date(b.date).getTime()
            );
          });
          
          props.setActivitiesAvailable(data);

          sendTheAnalytics(true)
          props.next({
            totalGuests: Number(guestCount),
            preferredDate: selectedDate,
          })

        } else {
          props.closeOrderPopUp(true,
            res && res.data && res.data.header && res.data.header.status && res.data.header.status.msg || t("activityBooking.error.getAvailableActivities"),
            "", true);
          sendTheAnalytics(false)

        }

      })

      .catch(() => {
        props.closeOrderPopUp(true, t("activityBooking.error.getAvailableActivities"), "", true);

      })

      .finally(() => {
        setShowLoader(false)
      })
  }

  const sendTheAnalytics = (isSuccess) => {
    try {

      props.sendAnalytics(
        props.guestDetail,
        props.currentWidgets.widgetType,
        isSuccess ? "FETCH SPA DATA - SUCCESS" : "FETCH SPA DATA - FAIL",
        { ...label, "layoutTab": props.currentHomePage.tabName, "element": "widget", "widgetSessionId": widgetSesstionId },
        0,
        props.guestIsLoggedIn
      );
    } catch (error) {
      return error;
    }

  }

  useEffect(()=>{
    scrollToTop();
  },[])

  return (
    <>
      <header className="inner-pages w-footer subpages">
        <a className="button-back" onClick={() => props.handleGoBack()}></a>
        <div className="heading align-center">
          <div class="splash-brand">
            <img src={`${CMSPath}${props.logo}`} />
          </div>
        </div>
      </header>
      
      <section class="widgets spa-listing">
        <div class="widget-header">
          {props.currentWidgetObj.widgetHeaderImageUrl && (
            <div class="widget-header-img">
              <img
                src={`${CMSPath}${props.currentWidgetObj.widgetHeaderImageUrl}`}
                alt={props.currentWidgetObj.displayName}
              />
            </div>
          )}

          <div class="widget-header-title">{t(`activityBooking.act3_heading`)}</div>
          {/* <div class="widget-header-subtitle">
            {t(`activityBooking.act3_subheading`)}
          </div> */}
        </div>

        <div class="form-row">
          <p class="heading">
            { t("activityBooking.preferred_date")}{" "}
            <span style={{ color: "red" }}>*</span>
          </p>
          <input
            type="button"
            value={
              selectedDate
                ? formatDateAsDateFormat(selectedDate, props.dateFormat)  // dd mm yy
                : t("activityBooking.select_date_placeholder")
            }
            onClick={() => setRenderDatePicker(!renderDatePicker)}
          />
        </div>

        <div class="form-row  ">
          <p class="heading">{t("activityBooking.Total_no_of_guests")} <span style={{ color: "red" }}>*</span></p>
          <div class="qty-input">

           <input type="text" value={guestCount} onChange={(event) => { console.log(event.target.value); setGuestCount(event.target.value) }} />
            <button disabled={isNaN(Number(guestCount))} onClick={(e) => { e.preventDefault();  setGuestCount(String(Number(guestCount)+1))}}>+</button>
            <button disabled={isNaN(Number(guestCount)) || Number(guestCount) <= 1} onClick={(e) => { e.preventDefault();  setGuestCount(String(Number(guestCount) - 1)) }}>-</button>

          </div>
        </div>

        <div class="row">
          <div class="form-controls">
            <button onClick={handleNext}>{t("activityBooking.continue")}</button>
            <button onClick={props.handleGoBack}>{t('activityBooking.back')}</button>
          </div>
        </div>

        {renderDatePicker && (
          <div
            className="overlay"
          // onClick={() =>}
          >
            <div
              onClick={(event) => {
               
                event.stopPropagation();
              }}
              class="overlay-date"
            >
              <style>{dateInputCss}</style>
              <DayPicker
                mode="single"
                selected={(selectedDate)}
                onSelect={(date) => { console.log(date, "date Selected is"); setSelectedDate(new Date(date)); setRenderDatePicker(!renderDatePicker) }
                }
                disabled={
                  {
                    before: new Date(props.serverTimeDate.split("T")[0])
                  }
                }
              />
            </div>
          </div>
        )}

        


      </section>
      {
        showLoader && <Loader displayMsg={t("activityBooking.loader_msg.getAvailableActivities")} /> // check whether to show close button, 
      }
    </>
  )
}
// ensure the time format , local only

const mapStateToProps = state => {
  return {
    installedAppVersion: state.store.installedAppVersion,
    installedAppBuildNo: state.store.installedAppBuildNo,
    logo: state.store.home.currentDuration.brandingInfo ?
      state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl : "",
    currentHomePage: state.store2.currentHomePage,
    currentWidgetObj: state.store.sideNavBar.currentWidget,
    guestDetail: state.store.home.guestDetails,
    guestIsLoggedIn: state.store2.guestIsLoggedIn,
    currentWidgets: state.store.sideNavBar.currentWidget,
    menuColor: state.store.home.MenuColor,
    serverTimeDate: state.store.home.serverTimeDate.date,
    timeFormat:
      state.store.home.clientConfig.extraConfigParam &&
      state.store.home.clientConfig.extraConfigParam.TIME_FORMAT_MERIDIEM,
    dateFormat: state.store.home.clientConfig.extraConfigParam
      ? state.store.home.clientConfig.extraConfigParam.DATE_FORMAT
      : "",

  }
}

const mapDispatchToProps = { setGoHome, closeOrderPopUp, sendAnalytics, popupOpenClose }

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation('translations')(Activities3));
